const efermedades = [
  { text: "Asma Bronquial", value: "Asma Bronquial" },
  { text: "Enfermedades Cardíacas", value: "Enfermedades Cardíacas" },
  { text: "Jaquecas", value: "Jaquecas" },
  { text: "Ulceras", value: "Ulceras" },
  { text: "Vértigos o Mareos", value: "Vértigos o Mareos" },
  { text: "Traumatismos de Cráneo", value: "Traumatismos de Cráneo" },
  { text: "Hipertensión", value: "Hipertensión" },
  { text: "Fiebre Reumática", value: "Fiebre Reumática" },
  { text: "Tuberculosis", value: "Tuberculosis" },
  { text: "Hernias", value: "Hernias" },
  { text: "Diabetes", value: "Diabetes" },
  { text: "Fracturas", value: "Fracturas" },
  { text: "Celiaquía", value: "Celiaquía" },
  { text: "Ninguna", value: "Ninguna" }
];

export default efermedades;
